export default __webpack_public_path__ + "static/login-04b5339c136633cb99e66c2f3472c2d2.jpg";